<div class="w-100 d-flex flex-column align-items-start justify-content-start gap-2">
    <label for="formFile" class="v4-color-white">{{label}}</label>
    <input #uploadInput class="form-control ms-input-view" type="file" id="formFile" (input)="handleFileUpload($event)" accept="{{accept}}">
    <p-progressBar style="width: 100%;" *ngIf="uploadingFile" [value]="uploadProgress"></p-progressBar>
</div>